import { defineMessages } from 'react-intl';

const messages = defineMessages({
  updateUser: {
    id: 'user.update.caption',
    defaultMessage: 'Edit {name}',
  },
  yourName: {
    id: 'user.yourName.header',
    defaultMessage: 'Your Name',
  },
  contactInformation: {
    id: 'user.contactInformation.header',
    defaultMessage: 'Contact Information',
  },
  firstName: {
    id: 'user.firstName.label',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'user.lastName.label',
    defaultMessage: 'Last Name',
  },
  email: {
    id: 'user.email.label',
    defaultMessage: 'Email',
  },
  buttonSave: {
    id: 'common.button.save',
    defaultMessage: 'SAVE',
  },
  buttonCancel: {
    id: 'common.button.cancel',
    defaultMessage: 'CANCEL',
  },
  generalError: {
    id: 'user.update.error.general',
    defaultMessage: 'Unable to update user',
  },
  userExists: {
    id: 'user.update.error.userExists',
    defaultMessage: 'User with provided email already exists!',
  },
  previousPasswordFailure: {
    id: 'change-password.previousPasswordFailure',
    defaultMessage: 'Current password did not match',
  },
  changePasswordSuccess: {
    id: 'change-password.success',
    defaultMessage: 'Success!',
  },
  changePasswordSection: {
    id: 'change-password.sectionHeading',
    defaultMessage: 'Change Password',
  },
  password: {
    id: 'change-password.passwordPlaceholder',
    defaultMessage: 'Current Password',
  },
  newPassword: {
    id: 'change-password.newPasswordPlaceholder',
    defaultMessage: 'New Password',
  },
  confirmPassword: {
    id: 'change-password.confirmPasswordPlaceholder',
    defaultMessage: 'Confirm New Password',
  },
  gotoYourProfile: {
    id: 'user.update.goto-your-profile',
    defaultMessage: 'Go to {yourProfile} to update other information about yourself.',
  },
  yourProfile: {
    id: 'user.update.your-profile',
    defaultMessage: 'Your Profile',
  },
});

export default messages;
